import React, { Component } from "react";
//import { withRouter } from "react-router-dom";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Card,
  Layer,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
  Console,
  Video,
  Close,
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";
import { withRouter } from "react-router-dom";
import auth from "./Security/Auth";
import GetHelpLIVE from "./GetHelpLIVE";
import GetHelpVIDEOSDOCS from "./GetHelpVIDEOSDOCS";

class GetHelp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      bdisplay: this.props.disp,
      bdisplayLDemo: false,
      bDisplayVideo: false,
    };

    this._setHide = this._setHide.bind(this);
    this._dispLDemo = this._dispLDemo.bind(this);
    this._dispVideosOne = this._dispVideosOne.bind(this);
    this._goHome = this._goHome.bind(this);
  }

  componentDidMount() {
    if (auth.getSearchParam()) {
      localStorage.removeItem("search");
    }
    this.state = {
      bdisplay: this.props.disp,
    };
    console.log("** From Gethelp prop");
    console.log(this.props.disp);
    console.log("** From Gethelp state");
    console.log(this.state.bdisplay);
  }
  _setHide = () => {
    this.setState({ bdisplay: false });
  };

  _dispLDemo = () => {
    this.setState({ bdisplayLDemo: true });
  };
  _dispVideosOne = () => {
    this.setState({ bDisplayVideo: true });
  };

  _hideHelp = () => {
    this.setState({ bdisplayLDemo: false, bDisplayVideo: false });
  };

  _goHome = () => {
    // this.props.history.push("/home");
  };

  render() {
    var displ = this.state.bdisplay;
    var dispLiveDemoHelp = this.state.bdisplayLDemo;
    var dispVideoIssueHelp = this.state.bDisplayVideo;
    return (
      <Box>
        {displ && (
          <Layer
            full={true}
            position="top"
           // height="medium"
            onClickOutside={this.props.hide}
            onEsc={this.props.hide}
          >
            <Box align="stretch" justify="start">
              <Main
                overflow="auto"
                background={{ image: "url('')" }}
                flex
                align="stretch"
                justify="start"
              >
                <Box
                  align="stretch"
                  justify="center"
                  flex="grow"
                  background={{ color: "background-back" }}
                  direction="row"
                >
                  <Box
                    align="stretch"
                    justify="start"
                    flex="shrink"
                    pad={{ horizontal: "large", vertical: "medium" }}
                    gap="medium"
                    basis="xlarge"
                  >
                    <Box align="center" justify="end" direction="row">
                      <Button
                        icon={<Close />}
                        onClick={this.props.hide}
                        secondary
                      />
                    </Box>
                    <Header
                      align="start"
                      direction="column"
                      flex={false}
                      justify="start"
                      gap="xxsmall"
                    >
                      {/*                       <Button
                        label="Home"
                        icon={<FormPrevious />}
                        gap="xsmall"
                        onClick={this._goHome}
                      /> */}
                      <Heading margin="none">Get Help-Knowledge base</Heading>
                    </Header>

                    <Box align="stretch" justify="center">
                      <Grid columns={{ size: "flex", count: 2 }} gap="small">
                        <Card
                          justify="start"
                          gap="small"
                          hoverIndicator
                          onClick={this._dispLDemo}
                        >
                          <CardHeader
                            align="center"
                            direction="row"
                            flex={false}
                            justify="between"
                            gap="medium"
                            pad="small"
                          >
                            <Heading margin="none" level="2" size="small">
                              Live Demonstration Issues
                            </Heading>
                          </CardHeader>
                          <CardBody pad="small">
                            <Paragraph color="text-strong">
                              Issue when scheduling a demo, issue with Citrix,
                              connetivity issues
                            </Paragraph>
                          </CardBody>
                        </Card>
                        <Card
                          justify="start"
                          gap="small"
                          onClick={this._dispVideosOne}
                        >
                          <CardHeader
                            align="center"
                            direction="row"
                            flex={false}
                            justify="between"
                            gap="medium"
                            pad="small"
                          >
                            <Heading margin="none" level="2" size="small">
                              Recorded Demonstration Issues
                            </Heading>
                          </CardHeader>
                          <CardBody pad="small" justify="end">
                            <Paragraph color="text-strong">
                              Problem with a video, with a streaming,
                            </Paragraph>
                          </CardBody>
                        </Card>
                      </Grid>
                    </Box>
                    <Box
                      align="center"
                      justify="center"
                      direction="row"
                      gap="small"
                    >
                      <Anchor
                        label="Contact Support team"
                        href="mailto:sdp.demo.support.staff@hpe.com?subject=HPE%20Demo%20Portal%20Issue/Question"
                        size="medium"
                      />
                    </Box>
                  </Box>
                </Box>
              </Main>
            </Box>
          </Layer>
        )}
        {dispLiveDemoHelp && (
          <GetHelpLIVE disp={dispLiveDemoHelp} hide={this._hideHelp} />
        )}
        {dispVideoIssueHelp && (
          <GetHelpVIDEOSDOCS disp={dispVideoIssueHelp} hide={this._hideHelp} />
        )}
      </Box>
    );
  }
}

export default withRouter(GetHelp);
